import * as Yup from "yup";

// Validation schemas for each tab
export const annualReturnsSchema = Yup.object({
  annualReturns: Yup.object({
    // lastAnnualReturnYear: Yup.string()
    //   .required("Year is required")
    //   .matches(/^\d{4}$/, "Year must be in YYYY format"),
    returns: Yup.array()
      .of(
        Yup.object().shape({
          // year: Yup.string()
          //   .required("Year is required")
          //   .matches(/^\d{4}$/, "Year must be in YYYY format"),
          dateOfReturn: Yup.string()
            .required("Date of this return is required")
            .matches(
              /^\d{4}\/\d{2}\/\d{2}$/,
              "Date must be in YYYY/MM/DD format"
            ),
          signatory: Yup.string().required("Signatory is required").nullable(),
          // fileUploads: Yup.object()
          //   .shape({
          //     annualReturns: Yup.mixed()
          //       .required("Annual returns file is required")
          //       .test(
          //         "file-or-name",
          //         "Must be a valid PDF file or a pre-existing file name",
          //         (value) => {
          //           if (!value) return false;
          //           // Allow File objects (new uploads)
          //           if (value instanceof File) {
          //             return (
          //               value.type === "application/pdf" &&
          //               value.size <= 2097152
          //             );
          //           }
          //           // Allow objects with a name property (pre-existing files)
          //           return typeof value === "string" && value.endsWith(".pdf");
          //         }
          //       ),
          //   })
          //   .required("File uploads are required")
          //   .nullable(),
        })
      )
      .required("At least one annual return is required"),
  }),
});
